module.exports = __webpack_public_path__ + "img/ico-next.7a7fbe3f.svg";